import Vue from "vue";
import VueJsonToCsv from "vue-json-to-csv";
const VJsonToCsv = {
  install(Vue) {
    Vue.component("VueJsonToCsv", VueJsonToCsv);
  },
};
Vue.use(VJsonToCsv);
